import { EnumWebOrderStep } from "nlb-buy-go-library";

const ContractCreateView = () => import("@views/app/contract-create/contract-create-view.vue");
const Login = () => import("@views/app/contract-create/login-view.vue");
const PrecheckView = () => import("@views/app/contract-create/precheck-view.vue");
const IdentificationDataConfirmationView = () => import("@views/app/contract-create/identfication-data-confirmation-view.vue");
const InstallmentPlanSelectionView = () => import("@views/app/contract-create/installment-plan-selection.view.vue");
const InstallmentPlanSelectionMultiView = () => import("@views/app/contract-create/installment-plan-selection-multi-view.vue");
const AdditionalContactInfoView = () => import("@views/app/contract-create/additional-contact-info-view.vue"); //to gre v identificationInfoView ---zbriši ko bo delujoče
const IdentificationInfoView = () => import("@views/app/contract-create/identification-info-view.vue");
const EmploymentFinancialInfoView = () => import("@views/app/contract-create/employment-financial-info-view.vue");
const Verification = () => import("@views/app/contract-create/verification-view.vue");
const VerificationEmail = () => import("@views/app/contract-create/verification-email-view.vue");
const ContractEndFailView = () => import("@/app/views/app/contract-create/contract-end-fail-view.vue"); 
const ContractEndSuccessView = () => import("@/app/views/app/contract-create/contract-end-success-view.vue");
// const PurchaseIdentificationInfoView = () => import("@/app/views/app/contract-create/purchase-identification-info-view.vue"); //to gre v PersonalInfoView ---zbriši ko bo delujoče
const PersonalInfoView = () => import("@/app/views/app/contract-create/personal-info-view.vue");
const PasswordResetTaxNumView = () => import("@/app/views/app/contract-create/password-reset-tax-number-view.vue");
const EmptyComponent = { template: "<div></div>" }

export const contractCreateCustomerRoutes = [
    {
        component: ContractCreateView,
        name: "contractCreate_home",
        path: "contract-create",
        children: [
            {
                // popraviti na VerificationPhone, ko bo komponenta
                component: Verification,
                name: "VerificationPhone",
                // popraviti na "verification-phone/:id", ko bo komponenta ločena
                path: "verification/:id",
                props: true,
                meta: {
                    buttons: [
                        // prva 2 gumba dati stran, ko bo komponenta
                        { name: "SendPin", action: "sendPinCode", visible: true },
                        { name: "ConfirmPin", action: "confirmPinCode", visible: true },
                    ],
                    navigation: { login: "Login", endFail: "EndFail", verifyEmail: "VerificationEmail" },
                    stepId: EnumWebOrderStep.WEB_verification,
                },            
            },
            {
                component: VerificationEmail,
                name: "VerificationEmail",
                path: "verification-email/:id",
                props: true,
                meta: {
                    buttons: [
                        { name: "SendValidationMail", action: "sendVerificationEmail", visible: true }
                    ],
                    navigation: { endFail: "EndFail", end: "ProcessEndScreen" },
                    stepId: EnumWebOrderStep.WEB_verification_email,
                },            
            },
            {
                component: Login,
                name: "Login",
                path: "login/:id",
                props: true,
                meta: {
                    buttons: [
                        { name: "Next", action: "login", visible: true }
                    ],
                    navigation: { precheck: "Precheck", idCheck: "IdentificationDataConfirmation", installmentPlan: "InstallmentPlanSelection", installmentPlanMulti: "InstallmentPlanSelectionMulti", endFail: "EndFail" },
                    stepId: EnumWebOrderStep.WEB_login,
                },            
            },
            {
                component: PasswordResetTaxNumView,
                name: "PassworResetTaxNum",
                path: "password/reset/tax-number/:id",
                props: true,
                meta: {
                    buttons: [
                        { name: "Back", action: "Back", visible: true },
                        { name: "Next", action: "passwordResetRequest", visible: true }
                    ],
                    navigation: { 
                        login: "Login",
                        end: "ProcessEndScreen"
                    },
                    stepId: EnumWebOrderStep.WEB_pass_reset_tax,
                },            
            },           
            {
                component: PrecheckView,
                name: "Precheck",
                path: "precheck/:id",
                props: true,
                meta: {
                    buttons: [
                        { name: "Next", action: "executePrecheck", visible: true }
                    ],
                    navigation: { nextStep: "InstallmentPlanSelection", nextStepMulti: "InstallmentPlanSelectionMulti", endFail: "EndFail" },
                    stepId: EnumWebOrderStep.WEB_precheck,
                },             
            },
            {
                component: InstallmentPlanSelectionView,
                name: "InstallmentPlanSelection",
                path: "installment-plan-selection/:id",
                props: true,
                meta: {
                    buttons: [
                        { name: "Next", action: "webNext", visible: true }
                    ],
                    // navigation: { nextStep: "PurchaseIdentificationInfo", nextStepCustomer: "AdditionalContactInfo", nextStepPreapproved: "EmploymentFinancialInfo", endFail: "EndFail" },
                    navigation: { nextStep: "PersonalInfo", nextStepCustomer: "AdditionalContactInfo", nextStepPreapproved: "EmploymentFinancialInfo", endFail: "EndFail" },
                    // nextstep: normal flow
                    // nextStepCustomer: skip PersonalInfo becouse they come from POS
                    // nextStepPreapproved: skip PersonalInfo and IdentificationInfo becouse they have data preapproved 
                    stepId: EnumWebOrderStep.WEB_installment_plan_Select,
                },             
            },
            {
                component: InstallmentPlanSelectionMultiView,
                name: "InstallmentPlanSelectionMulti",
                path: "installment-plan-selection-multi/:id",
                props: true,
                meta: {
                    buttons: [
                        { name: "Next", action: "webNext", visible: true }
                    ],
                    // navigation: { nextStep: "PurchaseIdentificationInfo", nextStepCustomer: "AdditionalContactInfo", nextStepPreapproved: "EmploymentFinancialInfo", endFail: "EndFail" },
                    navigation: { nextStep: "PersonalInfo", nextStepCustomer: "AdditionalContactInfo", nextStepPreapproved: "EmploymentFinancialInfo", endFail: "EndFail" },
                    // nextstep: normal flow
                    // nextStepCustomer: skip PersonalInfo becouse they come from POS
                    // nextStepPreapproved: skip PersonalInfo and IdentificationInfo becouse they have data preapproved 
                    stepId: EnumWebOrderStep.WEB_installment_plan_Select_Multi,
                },             
            },
            {
                component: PersonalInfoView,
                name: "PersonalInfo",
                path: "personal-information/:id",
                props: true,
                meta: {
                    buttons: [
                        { name: "Next", action: "webNext", visible: true }
                    ],
                    navigation: { nextStep: "IdentificationInfo", endFail: "EndFail" },
                    stepId: EnumWebOrderStep.WEB_personal_info,
                },
            },
            // {
            //     component: PurchaseIdentificationInfoView,
            //     name: "PurchaseIdentificationInfo",
            //     path: "purchase-identification/:id",
            //     props: true,
            //     meta: {
            //         buttons: [
            //             { name: "Next", action: "webNext", visible: true }
            //         ],
            //         navigation: { nextStep: "EmploymentFinancialInfo", endFail: "EndFail" },
            //     },             
            // },
            {
                component: IdentificationDataConfirmationView,
                name: "IdentificationDataConfirmation",
                path: "identification-info/:id",
                props: true,
                meta: {
                    buttons: [
                        { name: "Next", action: "webNext", visible: true }
                    ],
                    navigation: { nextStep: "InstallmentPlanSelection", endFail: "EndFail" },
                    stepId: EnumWebOrderStep.WEB_identification_data_confirm,
                },             
            },
            {
                component: IdentificationInfoView,
                name: "IdentificationInfo",
                path: "identification-info/:id",
                props: true,
                meta: {
                    buttons: [
                        { name: "Next", action: "webNext", visible: true }
                    ],
                    navigation: { nextStep: "EmploymentFinancialInfo", endFail: "EndFail" },
                        stepId: EnumWebOrderStep.WEB_identification_info,
                },            
            },
            {
                component: AdditionalContactInfoView,
                name: "AdditionalContactInfo",
                path: "additional-contact-info/:id",
                props: true,
                meta: {
                    buttons: [
                        { name: "Next", action: "webNext", visible: true }
                    ],
                    navigation: { nextStep: "EmploymentFinancialInfo", endFail: "EndFail" },
                    stepId: EnumWebOrderStep.WEB_additional_contact,
                },            
            },
            {
                component: EmploymentFinancialInfoView,
                name: "EmploymentFinancialInfo",
                path: "employment-financial-info/:id",
                props: true,
                meta: {
                    buttons: [
                        { name: "SignContract", action: "webCreateContract", visible: true }
                    ],
                    navigation: { nextStep: "Documentation", endSuccess: "EndSuccess", endFail: "EndFail" },
                    stepId: EnumWebOrderStep.WEB_employment_financial,
                },
            },
            {
                component: ContractEndFailView,
                name: "EndFail",
                path: "end-fail/:id",
                props: true,
                meta: {
                    buttons: [
                        { name: "BackToStoreError", action: "backToStoreError", visible: true }
                    ],
                    //buttons: { "Next": "createContract" },
                    navigation: { nextStep: "Documentation", endFail: "EndFail" },
                    stepId: EnumWebOrderStep.WEB_contract_fail,
                },
            },
            {
                component: ContractEndSuccessView,
                name: "EndSuccess", 
                path: "end-success/:id",
                props: true,
                meta: {
                    buttons: [
                        { name: "BackToStore", action: "backToStore", visible: true }
                    ],
                    //buttons: { "Next": "createContract" },
                    navigation: { nextStep: "Documentation", endFail: "EndFail" },
                    stepId: EnumWebOrderStep.WEB_contract_success,
                },
            },
            {
                component: EmptyComponent,
                name: "ContractRoot",
                path: ":id",
            }
        ]
    },
];